import * as actionType from './actions/Actions_name';

const initialState = {
    token: null,
    userID: null,
    error: null,
    loading: false
};

// authStart Handler
const authStart = (state, action) => {
    // console.log("Action Start Auth from Reducer Auth");
    // return new state in reducer
    const newState = Object.assign({}, state);
    newState.error = null;
    newState.loading = true;
    return newState;
}

// AuthSuccess Handler
const authSuccess = (state, action) => {
    // console.log("Action Success chiamata Async from Auth reducers");
    // return
    const newState = Object.assign({}, state);
    newState.error = null;
    newState.loading = false;
    newState.token = action.token;
    newState.userID = action.userId;
    return newState;
}

// AuthError Handler
const authFail = (state, action) => {
    // console.log("Action Error chamata dal reducer Auth")
    // return
    const newState = Object.assign({}, state);
    newState.error = action.error;
    newState.loading = false;
    return newState;
}

// Auth Logout Handler
const authLogout = (state, action) => {
    // console.log("Action Logout dal reducer")
    // return
    const newState = Object.assign({}, state);
    newState.error = null;
    newState.loading = false;
    newState.token = null;
    newState.userID = null;
    return newState;
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.AUTH_START: return authStart(state, action);
        case actionType.AUTH_SUCCESS: return authSuccess(state, action);
        case actionType.AUTH_FAIL: return authFail(state, action);
        case actionType.AUTH_LOGOUT: return authLogout(state, action);
        default:
            return state;

    }
};

export default reducer;